import type { SanityPageBuilderSection, SanityPageBuilderToolCardsCard, SanityPageBuilderToolCardsSection } from "@ouster/shared";
import { ToolCardsBlockView } from "~/features/blocks/inventory/tool-cards";
import { ToolCardView, type ToolCardViewProps } from "~/features/blocks/inventory/tool-cards/card";
import { SanityRichText } from "~/features/sanity/rich-text";
import { SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderToolCardsSection;
  };
};
type ToolCardsViewCard = ToolCardViewProps & Pick<SanityPageBuilderToolCardsCard, "_key">;
export function SanityToolCardsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.cards?.map<ToolCardsViewCard>(card => ({
    _key: card._key,
    description: card.description?.length ? <SanityRichText value={card.description} /> : undefined,
    media: <SanityMediaFigure fit="cover" media={card.media} ratio="1/1" />,
    title: card.title,
    url: card.url
  })) ?? [];
  return <ToolCardsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} getCardKey={(card, index) => card._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} isHighlighted={sectionContent.isHighlighted} mode={sectionSettings?.mode || "light"} renderCard={card => <ToolCardView {...card} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}